import type { ReactElement, ReactNode } from 'react';

type Props = {
  isInvalid: boolean;
  errorMessage: string | ReactNode;
  children: ReactNode;
  label?: ReactNode;
  htmlFor?: string;
  className?: string;
  invalidClassName?: string;
};

function ValidableControl({
  isInvalid,
  errorMessage,
  children,
  label,
  htmlFor,
  className,
  invalidClassName = 'is-invalid',
}: Props): ReactElement {
  return (
    <div
      className={[
        'c-form-group',
        isInvalid ? `${invalidClassName}` : '',
        className,
      ].join(' ')}
    >
      {label && htmlFor && (
        <label htmlFor={htmlFor}>{label}</label>
      )}
      {children}
      <div className="c-form-group__invalid-text">
        {errorMessage}
      </div>
    </div>
  );
}

export default ValidableControl;
